import { delayOffset, intersectionWatcher } from "@/lib/animation";

const selectors = {
  headerItems: ".animation--section-introduction > *",
  columnItems: ".statistics__grid-item",
};

export default node => {
  delayOffset(node, [selectors.headerItems, selectors.columnItems]);
  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer.destroy();
    },
  };
};
